import { render, staticRenderFns } from "./HandWriting.vue?vue&type=template&id=3962f0af"
import script from "./HandWriting.vue?vue&type=script&lang=js"
export * from "./HandWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3962f0af')) {
      api.createRecord('3962f0af', component.options)
    } else {
      api.reload('3962f0af', component.options)
    }
    module.hot.accept("./HandWriting.vue?vue&type=template&id=3962f0af", function () {
      api.rerender('3962f0af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/HandWriting.vue"
export default component.exports